"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (coll) {
    return coll[Symbol.iterator] && coll[Symbol.iterator]();
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/async/internal/getIterator.js
// module id = NScS
// module chunks = 0